import { render, staticRenderFns } from "./IntroReminder.vue?vue&type=template&id=0b691f8c&scoped=true&"
import script from "./IntroReminder.vue?vue&type=script&lang=js&"
export * from "./IntroReminder.vue?vue&type=script&lang=js&"
import style0 from "./IntroReminder.vue?vue&type=style&index=0&id=0b691f8c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b691f8c",
  null
  
)

export default component.exports